/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import ImageUploader from 'vue-image-upload-resize'  //ImageUploader
import * as VueGoogleMaps from 'vue2-google-maps'
const $cookies = require('vue-cookies')

Vue.use(Vuesax)
Vue.use(require('vue-cookies'))
Vue.use(ImageUploader);
Vue.use(require('vue-moment'))
Vue.use($cookies);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAayvZQxZHFax_zEvtY1aA5Fvf3i58Mm0g ',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


import '@fortawesome/fontawesome-free/css/all.css';

import 'viewerjs/dist/viewer.css'
import Viewer from "v-viewer";
Vue.use(Viewer,{
    defaultOptions:{
        zIndex:999999
    }
})
// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// VeeValidate
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

import './assets/css/datepicker.css';
import Datepicker from 'vuejs-datepicker';
Vue.use(Datepicker);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import VueI18n from 'vue-i18n';
import zh from './lang/zh'
import en from './lang/en'
import zh_cn from './lang/zh_cn'
Vue.use(VueI18n);
if (!$cookies.get('lang')) {
    $cookies.set('lang', 'zh');
}
const i18n = new VueI18n({
    locale: $cookies.get('lang') || 'zh',
    messages: {
        'zh': zh,
        'en': en,
        'zh_cn':zh_cn
    }
})

import {zhS,zhT} from './lang/language.js'
String.prototype.tran = function () {
    let s1 = ''
    let s2 = ''
    const zhChoose = $cookies.get('lang')
    if (zhChoose === 'zh') {
        s1 = zhS
        s2 = zhT
    } else if (zhChoose === 'zh_cn') {
        s1 = zhT
        s2 = zhS
    } else {
        return this
    }
    let a = ''
    for (let i = 0; i < this.length; i++) {
        const c = this.charAt(i)
        const p = s1.indexOf(c)
        a += p < 0 ? c : s2.charAt(p)
    }
    return a
}

import qs from 'qs';
Vue.prototype.$qs = qs;

//acl.js
import {aclDirective,roleDirective} from './assets/utils/acl'
Vue.directive('acl',aclDirective)
Vue.directive('role',roleDirective)


// Feather font icon
require('./assets/css/iconfont.css')

Vue.prototype.isMobile = function(){
    return screen.width < 500 ;
}
import moment from 'moment'

Vue.filter('dateFormat', function (value) {
    return value ? moment(value).format('DD/MM/YYYY') : '--' ;
})
Vue.filter('timeFormat', function (value) {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : '--' ;
})
Vue.filter('priceFormat', function (value) {
    if(value){
        return Number(value).toLocaleString('en-US');
    }
    return value;
})
Vue.filter('percentFormat', function (value) {
    if(value){
        return Number(val * 100) + "%";
    }
    return value;
})

import highcharts from 'highcharts'
import VueHighCharts from 'highcharts-vue'
import highcharts3d from 'highcharts/highcharts-3d'
Vue.use(VueHighCharts)
highcharts3d(highcharts)


Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
